import React, {useState} from "react";
import {FiShare2} from "react-icons/fi";
import {RoundTripFlight} from "../../models/RoundTripFlight";
import {SharedFlightService} from "../../services/SharedFlightService";
import {useTranslation} from "../../i18n/LanguageProvider";

interface Props {
  flight: RoundTripFlight;
  className?: string;
  compact?: boolean;
}

const ShareIcon = FiShare2 as unknown as React.FC<{size?: number}>;

export default function ShareFlightButton({flight, className = "", compact = false}: Props) {
  const {t} = useTranslation();
  const [state, setState] = useState<"idle" | "loading" | "copied" | "manual" | "error">("idle");
  const [url, setUrl] = useState("");

  const share = async () => {
    if (state === "loading") return;
    setState("loading");
    try {
      const link = url || await SharedFlightService.create(flight);
      setUrl(link);
      try {
        await navigator.clipboard.writeText(link);
        setState("copied");
      } catch {
        setState("manual");
      }
    } catch {
      setState("error");
    }
  };

  return (
    <div className={`relative ${className}`}>
      <button type="button" onClick={share} disabled={state === "loading"}
        aria-label={t("share.button")}
        className="share-flight-button flex min-h-[44px] items-center justify-center gap-2 rounded-full border border-[#DED5F8] bg-white px-4 text-xs font-bold text-[#712FFF] transition hover:bg-[#F4F0FF] disabled:opacity-60">
        <ShareIcon size={15}/>
        {!compact && <span className="share-flight-label whitespace-nowrap">{state === "loading" ? t("share.loading") : state === "copied" ? t("share.copied") : t("share.button")}</span>}
      </button>
      {state === "manual" && <div className="absolute right-0 z-30 mt-2 w-72 max-w-[85vw] rounded-xl bg-white p-3 shadow-xl ring-1 ring-[#DED5F8]">
        <label className="mb-2 block text-xs font-semibold text-primary" htmlFor={`share-${flight.outbound_flight.departure_date}-${flight.outbound_flight.departure_iata}`}>{t("share.copyManually")}</label>
        <input id={`share-${flight.outbound_flight.departure_date}-${flight.outbound_flight.departure_iata}`}
          readOnly value={url} onFocus={event => event.target.select()}
          className="w-full rounded-lg border border-[#DED5F8] p-2 text-xs" />
      </div>}
      {state === "error" && <p role="alert" className="absolute right-0 z-30 mt-2 w-56 rounded-lg bg-white p-2 text-xs text-red-700 shadow-lg">{t("share.error")}</p>}
    </div>
  );
}
